import { useTranslation } from "react-i18next";
import { CustomCheckBox } from "../../../../components";
import { MapMembers } from "../../../../types/common.interface";

interface Props {
  state: MapMembers;
  setState: (state: MapMembers) => void;
}

const CheckMarks = ({ state, setState }: Props) => {
  const { t } = useTranslation();
  return (
    <>
      {state.student !== undefined && (
        <div>
          <CustomCheckBox
            onChecked={() => setState({ ...state, student: !state.student })}
            isChecked={state.student}
            label={t("student")}
          />{" "}
        </div>
      )}
      {state.driver !== undefined && (
        <div>
          <CustomCheckBox
            onChecked={() => setState({ ...state, driver: !state.driver })}
            isChecked={state.driver}
            label={t("driver")}
          />{" "}
        </div>
      )}
      {state.school !== undefined && (
        <div>
          <CustomCheckBox
            onChecked={() => setState({ ...state, school: !state.school })}
            isChecked={state.school}
            label={t("school")}
          />
        </div>
      )}
    </>
  );
};

export default CheckMarks;
